import { Injectable } from '@angular/core';

import { FeatureFlag } from '@models/feature-flag.model';

import { PERIOD_CLOSE_ROUTES_FEATURE_FLAGS } from '@shared/constants/feature-flags-guards/period-close-routes-feature-flags.const';
import { ROUTING_PATH } from '@shared/constants/routingPath';
import { BasicRedirectToNextTabGuard } from '@shared/guards/basic-redirect-to-next-tab.guard';
import { Flags } from '@shared/services/launch-darkly.service';

@Injectable({
  providedIn: 'root',
})
export class PrepaidsGuard extends BasicRedirectToNextTabGuard {
  protected prefix = `/${ROUTING_PATH.CLOSING.INDEX}`;
  protected defaultNavigateUrl = `/${this.prefix}/${ROUTING_PATH.CLOSING.CLOSE_SUMMARY}`;
  protected featureFlag = FeatureFlag.PREPAIDS as keyof Flags;
  protected routerPathsAndFeatureFlags = PERIOD_CLOSE_ROUTES_FEATURE_FLAGS;
}
